module.exports = __webpack_public_path__ + "img/skd-folded-light.c77db1ff.svg";